import React from 'react';
import { Dialog, FlatButton, CircularProgress } from 'material-ui';
import Warning from 'material-ui/svg-icons/alert/warning';

const DialogError = ({messages, handleClose, actions}) => {
  const _actions = [<FlatButton label="OK" primary={true} onClick={handleClose}/>]
  const {openMessage, message, error} = messages
  if (error){
    return (
      <Dialog actions={_actions} modal={true} open={openMessage} onRequestClose={handleClose}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        style={{marginLeft: '25%', width: '50%'}} >
        <div className='row'>
          <div className='col-sm-2'>
            <Warning style={{fill: 'orange', height: '48px', width: '48px', marginRight: '20px' }}/>
          </div>
          <div className='col-sm-10'>
            <span style={{marginLeft: 30, fontWeight: 900}}>{message}</span>
          </div>
        </div>
      </Dialog>
    )
  } else {
    return (
      <Dialog actions={actions} modal={true} open={openMessage} onRequestClose={handleClose}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        style={{marginLeft: '25%', width: '50%'}} >
        <CircularProgress size={60} thickness={7} />
        <span style={{marginLeft: 30, fontWeight: 900}}>{message}</span>
      </Dialog>
    )
  }
}

export default DialogError



// WEBPACK FOOTER //
// ./src/shared/routes/routeResume/components/dialogError.js